import React from "react";
import styled from "styled-components";

type TextCharDelimiterNavProps = {
  onClick: () => void;
  active: boolean;
};

const TextCharDelimiterNav = ({
  onClick,
  active,
}: TextCharDelimiterNavProps) => {
  return <DelimiterNav onClick={onClick} active={active} />;
};

const DelimiterNav = styled.div<{ active: boolean }>`
  border: 1px solid black;
  margin-top: 0rem;
  width: 0.5rem;
  background-color: ${(props) => (props.active ? "black" : "transparent")};
  cursor: pointer;
  :hover {
    opacity: 0.5;
  }
`;

export default TextCharDelimiterNav;
